import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-terms-and-conditions',
    templateUrl: './terms-and-conditions.component.html',
    styleUrls: ['./terms-and-conditions.component.css'],
    standalone: false
})
export class TermsAndConditionsComponent implements OnInit {

  serverErrorMessages: string;
  successMessage: string;
  loading: boolean = true;
  accepted=false;
  isDisabled=true;
  constructor(private loginservice: LoginService, private router: Router) { }

  ngOnInit(): void {
    if(this.loginservice.isLoggedIn()){
     //console.log("Already logged in! Log Out first");
      this.loginservice.getUserProfile().subscribe(
        res => {
          this.router.navigateByUrl('/home');
        },
        err => {
         //console.log('Did not get user', err);
        });
    }
    this.loading = false;
  }

  controlBtn() {
    if (this.accepted) this.isDisabled=false;
    else this.isDisabled=true;
    console.log('change', this.isDisabled, this.accepted)
  }

  onSubmit(){
    console.log('submitting')
    this.router.navigateByUrl('/change-password-first-login');
  }


}
